import React from 'react';
import { Mutation } from "react-apollo"
import { ADD_BLOG_COMMENT } from "../queries";
import { getUserId } from '../../../utils/localStorage';

const AddCommentButton = ({commenterId,commenterType,blogId,content,refetchBlog,setContent}) => {
    return(
        <Mutation mutation={ADD_BLOG_COMMENT} 
            variables= {{commenterId:getUserId(),commenterType:"AdminUser",blogId:blogId,content:content}}
            onCompleted={refetchBlog}>
            
            {(addComment, { loading, error }) => (
                <div className='addCommentButton' onClick={() => {
                    if (content){
                        addComment()
                        setContent("")
                    }}}>
                    + Add comment
                </div>
            )}

          </Mutation>
    )
}

export default AddCommentButton;


// WEBPACK FOOTER //
// ./src/components/Blogs/Comments/AddCommentButton.js